export default class BlockForm {
    constructor(container, options) {
        const defaultOptions = {
            apiEndpoint: '/umbraco/forms/api/v1/definitions/{id}',
            submitEndpoint: '/umbraco/forms/api/v1/entries/{id}',
            csrfEndpoint: '/api/v1/forms/csrf-token',
            pageEndpoint: '/api/v1/forms/page-url/{id}',
            formContainer: '.form',
            formId: '',
            pageId: '',
            culture: '',
            recaptchaSiteKey: '',
            csrfEnabled: false,
            loaderEnabled: true,
            loaderImage: ''
        };
        this.uniqueId = Date.now().toString(36) + Math.random().toString(36).substr(2);
        this.setConstants();
        this.options = Object.assign({}, defaultOptions, options);
        this.container = document.querySelector(container);
        this.formContainer = this.container.querySelector(this.options.formContainer);
        this.formDataTypes = {};
        this.thankYou = {
            type: this.thankYouTypes.message,
            url: ''
        };

        this.recaptcha = {
            inForm: false,
            ready: false,
            fieldId: '',
        };

        if(this.options.loaderEnabled) {
            this.renderLoader();
            this.showLoader();
        }
        this.loadForm();
    }

    setConstants() {
        this.thankYouTypes = {
            message: 'MESSAGE',
            page: 'PAGE'
        };
        this.dataType = {
            string: 'STRING',
            file: 'FILE',
            array: 'ARRAY'
        }
        this.fieldTypes = {
            'short answer': this.fieldTypeShortAnswer.bind(this),
            'long answer': this.fieldTypeLongAnswer.bind(this),
            'date': this.fieldTypeDate.bind(this),
            'date and time': this.fieldTypeDateAndTime.bind(this),
            'date with date check': this.fieldTypeDate.bind(this),
            'checkbox': this.fieldTypeCheckbox.bind(this),
            'file upload': this.fieldTypeFileUpload.bind(this),
            'password': this.fieldTypePassword.bind(this),
            'multiple choice': this.fieldTypeMultipleChoice.bind(this),
            'data consent': this.fieldTypeDataConsent.bind(this),
            'dropdown': this.fieldTypeDropdown.bind(this),
            'single choice': this.fieldTypeSingleChoice.bind(this),
            'title and description': this.fieldTypeTitleDescription.bind(this),
            'hidden': this.fieldTypeHidden.bind(this),
            'recaptcha v3 with score': this.fieldTypeRecaptcha3.bind(this),
        };
    }

    renderLoader() {
        var loadingInner = document.createElement('div');
        this.addAttribute(loadingInner, 'class', 'container');

        this.loader = document.createElement('div');
        this.addAttribute(this.loader, 'class', 'loading-container');

        var loadingImage = document.createElement('img');
        loadingImage.alt = 'loading graphic';
        loadingImage.src = this.options.loaderImage;

        loadingInner.appendChild(loadingImage);

        this.loader.appendChild(loadingInner);

        this.formContainer.appendChild(this.loader);
    }

    showLoader() {
        this.loader.classList.add('show');
    }

    hideLoader() {
        this.loader.classList.remove('show');
    }


    async getCsrfToken() {
        let response = await fetch(this.options.csrfEndpoint);
        if(response.status === 200) {
            let data = await response.json();
            return data;
        }

        return {
            result: false
        }
    }

    async getThankYouPageUrl(id) {
        let response = await fetch(this.options.pageEndpoint.replace('{id}', id));
        if(response.status === 200) {
            let data = await response.json();
            return data;
        }

        return {
            url: ''
        }
    }

    formError(msg) {
        let formError = this.container.querySelector('.form-error');
        if(typeof formError === 'undefined' || formError === null) {
            formError = document.createElement('div');
            this.addAttribute(formError, 'class', 'container form-error');

            const errorRow = document.createElement('div');
            this.addAttribute(errorRow, 'class', 'row');

            const errorColumn = document.createElement('div');
            this.addAttribute(errorColumn, 'class', 'col-12');

            const errorMsg = document.createElement('div');
            this.addAttribute(errorMsg, 'class', 'msg');

            errorColumn.appendChild(errorMsg);
            errorRow.appendChild(errorColumn);
            formError.appendChild(errorRow);
        }
        formError.querySelector('.msg').innerHTML = msg;
        this.container.prepend(formError);
    }

    async loadForm() {
        if(this.options.csrfEnabled) {
            const csrfToken = await this.getCsrfToken();
            if(csrfToken.result != false) {
                this.csrfToken = csrfToken;
            }
            else {
                this.formError('Could not load form');
                return;
            }
        }

        var url = this.options.apiEndpoint.replace('{id}', this.options.formId);
        if(this.options.pageId !== '' && this.options.pageId != 0) {
            url += '?contentId=' + this.options.pageId;
        }
        if(this.options.pageId !== '') {
            url += ((url.indexOf('?') >= 0) ? '&' : '?');
            url += 'culture=' + this.options.culture;
        }


        let response = await fetch(url);
        if(response.status === 200) {
            let data = await response.json();
            await this.setupThankYou(data);
            this.renderForm(data);
            this.initDatePickers();
        }
        else {
            this.renderFormLoadError();
        }
    }

    async setupThankYou(settings) {
        if(typeof settings.gotoPageOnSubmit !== 'undefined') {
            this.thankYou.type = this.thankYouTypes.page;
            var pageSettings = await this.getThankYouPageUrl(settings.gotoPageOnSubmit);
            if(pageSettings.result != false) {
                this.thankYou.url = pageSettings.url;
            }
        }
        else {
            this.thankYouElement = document.createElement('div');
            this.addAttribute(this.thankYouElement, 'class', 'container thank-you');

            var thankYouRow = document.createElement('div');
            this.addAttribute(thankYouRow, 'class', 'row');

            var thankYouCol = document.createElement('div');
            this.addAttribute(thankYouCol, 'class', 'col-12');

            if(settings.messageOnSubmitIsHtml) {
                thankYouCol.innerHTML = settings.messageOnSubmit;
            }
            else {
                thankYouCol.innerText = settings.messageOnSubmit;
            }
            thankYouRow.appendChild(thankYouCol);
            this.thankYouElement.appendChild(thankYouRow);

            this.formContainer.appendChild(this.thankYouElement);
        }
    }

    renderForm(data) {
        this.formElement = document.createElement('form');
        this.addAttribute(this.formElement, 'id', 'form-' + this.uniqueId);

        this.renderPages(this.formElement, data.pages);
        this.formContainer.appendChild(this.formElement);
        this.renderButton(this.formElement, data);
        this.formElement.classList.add('active');
        if(this.options.loaderEnabled) {
            this.hideLoader();
        }
    }

    renderPages(elem, pages) {
        for(var i = 0; i < pages.length; i++) {
            this.renderFieldSets(elem, pages[i].fieldsets);
        }
    }

    renderFieldSets(elem, fieldSets) {
        let container = document.createElement('div');
        this.addAttribute(container, 'class', 'container fields');
        for(var i = 0; i < fieldSets.length; i++) {
            this.renderColumns(container, fieldSets[i].columns);
        }
        elem.appendChild(container);
    }

    renderColumns(elem, columns) {
        let row = document.createElement('div');
        this.addAttribute(row, 'class', 'row');
        for(var i = 0; i < columns.length; i++) {
            let column = document.createElement('div');
            this.addAttribute(column, 'class', 'col-12 col-md-' + columns[i].width);

            this.renderFields(column, columns[i].fields);

            row.appendChild(column);
        }
        elem.appendChild(row);
    }

    renderFields(elem, fields) {
        for(var i = 0; i < fields.length; i++) {
            let fieldType = fields[i].type.name.toLowerCase();
            if(typeof this.fieldTypes[fieldType] !== 'undefined') {
                let field = this.fieldTypes[fieldType](fields[i]);
                elem.appendChild(field);
            }
            else {
                let field = document.createElement('div');
                field.innerHTML = fieldType + ' Not Supported';
                elem.appendChild(field);
            }

        }
    }

    renderButton(formElement, data) {
        const container = document.createElement('div');
        this.addAttribute(container, 'class', 'container buttons')

        const row = document.createElement('div');
        this.addAttribute(row, 'class', 'row')

        const column = document.createElement('div');
        this.addAttribute(column, 'class', 'col')

        const buttonElement = document.createElement('button');
        var submitLabel = data.submitLabel;
        if (submitLabel === '') {
            submitLabel = 'Submit';
        }
        buttonElement.innerText = submitLabel;
        this.addAttribute(buttonElement, 'type', 'submit');
        this.addAttribute(buttonElement, 'class', 'btn btn-sm btn-primary');
        buttonElement.addEventListener('click', this.submitForm.bind(this));

        column.appendChild(buttonElement);
        row.appendChild(column);
        container.appendChild(row);
        formElement.appendChild(container);
    }

    initDatePickers() {
        let datePickers = this.container.querySelectorAll('.flatpickr.date-only');
        for(var i = 0; i < datePickers.length; i++) {
            this.initDatePicker(datePickers[i]);
        }

        let dateTimePickers = this.container.querySelectorAll('.flatpickr.date-time');
        for(var i = 0; i < dateTimePickers.length; i++) {
            this.initDateTimePicker(dateTimePickers[i]);
        }
    }

    async submitForm(e) {
        e.preventDefault();
        e.stopPropagation();
        this.showLoader();
        this.disableSubmit();
        this.clearValidationErrors()

        if (this.recaptcha.inForm) {
            if(this.recaptcha.ready) {
                window.grecaptcha.execute(this.options.recaptchaSiteKey, {action: "umbracoform_submit"}).then((token) => {
                    var hiddenField = this.container.querySelector('#form-' + this.uniqueId + '-recaptcha-' + this.recaptcha.fieldId);
                    hiddenField.value = token;
                    this.processSubmit();
                });
            }
            else {
                // TODO make a nice error message to say try again.
                alert('recaptcha not ready');
            }
        } else {
            await this.processSubmit();
        }
    }

    async processSubmit() {
        const formId = this.options.formId;
        const data = {
            contentKey: this.options.pageId,
            culture: this.options.culture,
            values: {}
        };

        const formData = new FormData(this.formElement);
        window.formData = formData;

        for (const [key, value] of formData) {
            if(this.formDataTypes[key] === this.dataType.file) {

                const fileName = value.name;
                const fileContents = await this.getFileAsBase64(value);
                if (typeof data.values[key] === 'undefined') {
                    data.values[key] = [];
                }

                data.values[key].push({
                    fileName: fileName,
                    fileContents: fileContents
                });
            }
            else if(this.formDataTypes[key] === this.dataType.array) {
                if (typeof data.values[key] === 'undefined') {
                     data.values[key] = [];
                }
                data.values[key].push(value);
            }
            else {
                data.values[key] = value
            }
        }

        var headers = {
            "Content-Type": "application/json"
        };

        if(this.options.csrfEnabled) {
            headers[this.csrfToken.headerName] = this.csrfToken.requestToken;
        }


        let response = await fetch(this.options.submitEndpoint.replace('{id}', formId), {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data),
        });

        if (response.status === 202) {
            this.processThankYou();
        }
        else if (response.status === 422) {
            let validationErrors = await response.json();
            if(typeof validationErrors.errors !== 'undefined') {
                this.renderValidationErrors(validationErrors.errors);
            }
        }
        else {
            console.log("Error (" + response.status + "): " + response.statusText);
        }
        this.enableSubmit();
        this.hideLoader();
    }

    processThankYou() {
        if(this.thankYou.type == this.thankYouTypes.page && this.thankYou.url !== '') {
            window.location = this.thankYou.url;
            return;
        }
        else {
            this.formElement.classList.remove('active');
            this.thankYouElement.classList.add('active');

            this.thankYouElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }

    clearValidationErrors() {
        var errorMessages = this.container.querySelectorAll('.fieldtype.error');

        for(const elem of errorMessages) {
            elem.classList.remove('error');
        }
    }

    renderValidationErrors(validationErrors) {
        for(const [field, messages] of Object.entries(validationErrors)) {
            // const elem = this.container.querySelector('.error-'+ field);
            const elem = this.container.querySelector('[data-alias='+field+']');

            if(typeof elem !== 'undefined') {
                elem.classList.add('error');
                elem.querySelector('.error-message .msg').innerHTML = '<div>' + messages.join('</div><div>') + '<div>';
            }
        }

        var firstError = this.container.querySelector('.fieldtype.error');
        if(firstError instanceof Element) {
            firstError.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }

    initDatePicker(datePicker) {
        let instance = flatpickr(datePicker, {
            altInput: true,
            altFormat: "D, d M Y",
            dateFormat: "Y-m-d",
            disableMobile: false,
            locale: {
                firstDayOfWeek: 1 // start week on monday
            },
            onOpen: () => {
                let flatpickrWeekday = document.querySelectorAll('.flatpickr-weekday')
                flatpickrWeekday.forEach(day => {
                    day.innerHTML = day.innerHTML.trim().slice(0, 1)
                });
            },
            onChange: (dateObj, dateStr) => {
                const dateArr = dateStr.replaceAll(',', '').split(' ')
                const monthStr = ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dateArr[2]) / 3 + 1)

                const venueBook = {
                    year: dateArr[3],
                    month: monthStr,
                    day: dateArr[1]
                }

                this.selectedDate = venueBook;
            }
        });

        const dateCheck = datePicker.getAttribute('data-allowed-date');
        switch (dateCheck) {
            case 'TodayOrEarlier':
                instance.set('maxDate', 'today');
                break;
            case 'TodayOrLater':
                instance.set('minDate', 'today');
                break;
            default:
                break;
        }
    }

    initDateTimePicker(datePicker) {
        let instance = flatpickr(datePicker, {
            altInput: true,
            altFormat: "D, d M Y - h:i K",
            dateFormat: "Y-m-d H:i:00",
            disableMobile: false,
            enableTime: true,
            minuteIncrement: 30,
            locale: {
                firstDayOfWeek: 1 // start week on monday
            },
            onOpen: () => {
                let flatpickrWeekday = document.querySelectorAll('.flatpickr-weekday')
                flatpickrWeekday.forEach(day => {
                    day.innerHTML = day.innerHTML.trim().slice(0, 1)
                });
            },
            onChange: (dateObj, dateStr) => {
                const dateArr = dateStr.replaceAll(',', '').split(' ')
                const monthStr = ("JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(dateArr[2]) / 3 + 1)

                const venueBook = {
                    year: dateArr[3],
                    month: monthStr,
                    day: dateArr[1]
                }

                this.selectedDate = venueBook;
            }
        });

        const dateCheck = datePicker.getAttribute('data-allowed-date');
        switch (dateCheck) {
            case 'TodayOrEarlier':
                instance.set('maxDate', 'today');
                break;
            case 'TodayOrLater':
                instance.set('minDate', 'today');
                break;
            default:
                break;
        }
    }

    renderFormLoadError() {
        this.formContainer.innerHTML = 'Could not load form.';
    }

    // ------------------------------------------------------------------------------------------------
    // Field Types
    // ------------------------------------------------------------------------------------------------
    fieldTypeShortAnswer(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldElement = document.createElement("input");
        this.addAttribute(fieldElement, "id", 'form-' + this.uniqueId + '-fieldelem-' + field.id);
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttributeFromFieldSettings(fieldElement, "type", field.settings, "fieldType", "text");
        this.addAttributeFromFieldSettings(fieldElement, "maxlength", field.settings, "maximumLength", "");
        this.addAttributeFromFieldSettings(fieldElement, "placeholder", field.settings, "placeholder", "");
        this.addAttributeFromFieldSettings(fieldElement, "value", field.settings, "defaultValue", "");

        return this.addStandardFieldWrapper(field,  fieldElement);
    }

    fieldTypeLongAnswer(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldElement = document.createElement("textarea");
        this.addAttribute(fieldElement, "id", 'fieldelem-' + field.id);
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttributeFromFieldSettings(fieldElement, "maxlength", field.settings, "maximumLength", "");
        this.addAttributeFromFieldSettings(fieldElement, "placeholder", field.settings, "placeholder", "");
        this.addAttributeFromFieldSettings(fieldElement, "rows", field.settings, "numberOfRows", "5");
        this.addAttributeFromFieldSettings(fieldElement, "value", field.settings, "defaultValue", "");

        return this.addStandardFieldWrapper(field, fieldElement);
    }

    fieldTypeDate(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const wrapper = document.createElement('div');
        this.addAttribute(wrapper, 'class', 'wrapper');

        const fieldElement = document.createElement('input');
        this.addAttribute(fieldElement, 'class' , 'flatpickr flatpickr-input date-only');
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttribute(fieldElement, 'type' , 'text');
        this.addAttribute(fieldElement, 'readonly' , 'readonly');
        this.addAttributeFromFieldSettings(fieldElement, "placeholder", field.settings, "placeholder", "");
        this.addAttributeFromFieldSettings(fieldElement, "data-allowed-date", field.settings, "allowedDate", "");

        wrapper.appendChild(fieldElement);
        wrapper.innerHTML += '<svg class="icon dropdown-icon icon-calendar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.31 22"><path d="M18.61,1.69h-2.54V.85c0-.47-.38-.85-.85-.85s-.85,.38-.85,.85v.85H5.92V.85C5.92,.38,5.54,0,5.08,0c-.47,0-.85,.38-.85,.85v.85H1.69c-.93,0-1.69,.76-1.69,1.69V20.31c0,.93,.76,1.69,1.69,1.69H18.61c.93,0,1.69-.76,1.69-1.69V3.39c0-.93-.76-1.69-1.69-1.69m0,5.08H1.69V3.39h2.54v.85c0,.47,.38,.85,.85,.85,.47,0,.85-.38,.85-.85h0v-.85H14.39v.85c0,.47,.38,.85,.85,.85s.85-.38,.85-.85h0v-.85h2.54v3.38Z"></path></svg>';
        return this.addStandardFieldWrapper(field, wrapper);

    }

    fieldTypeDateAndTime(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const wrapper = document.createElement('div');
        this.addAttribute(wrapper, 'class', 'wrapper');

        const fieldElement = document.createElement('input');
        this.addAttribute(fieldElement, 'class' , 'flatpickr flatpickr-input date-time');
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttribute(fieldElement, 'type' , 'text');
        this.addAttribute(fieldElement, 'readonly' , 'readonly');
        this.addAttributeFromFieldSettings(fieldElement, "placeholder", field.settings, "placeholder", "");
        this.addAttributeFromFieldSettings(fieldElement, "data-allowed-date", field.settings, "allowedDate", "");

        wrapper.appendChild(fieldElement);
        wrapper.innerHTML += '<svg class="icon dropdown-icon icon-calendar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.31 22"><path d="M18.61,1.69h-2.54V.85c0-.47-.38-.85-.85-.85s-.85,.38-.85,.85v.85H5.92V.85C5.92,.38,5.54,0,5.08,0c-.47,0-.85,.38-.85,.85v.85H1.69c-.93,0-1.69,.76-1.69,1.69V20.31c0,.93,.76,1.69,1.69,1.69H18.61c.93,0,1.69-.76,1.69-1.69V3.39c0-.93-.76-1.69-1.69-1.69m0,5.08H1.69V3.39h2.54v.85c0,.47,.38,.85,.85,.85,.47,0,.85-.38,.85-.85h0v-.85H14.39v.85c0,.47,.38,.85,.85,.85s.85-.38,.85-.85h0v-.85h2.54v3.38Z"></path></svg>';
        return this.addStandardFieldWrapper(field, wrapper);
    }

    fieldTypeCheckbox(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const wrapper = document.createElement('label');

        const fieldElement = document.createElement('input');
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttribute(fieldElement, 'type' , 'checkbox');
        this.addAttribute(fieldElement, 'value' , field.settings.defaultValue);
        this.addAttributeFromFieldSettings(fieldElement, "placeholder", field.settings, "placeholder", "");

        const textElement = document.createElement('span');
        textElement.innerHTML = field.caption;

        wrapper.appendChild(fieldElement);
        wrapper.appendChild(textElement);

        return this.addSimpleFieldWrapper(field, wrapper);
    }

    fieldTypeHidden(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldElement = document.createElement('input');
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttribute(fieldElement, 'type' , 'hidden');
        this.addAttribute(fieldElement, 'value' , field.settings.defaultValue);
        return this.addSimpleFieldWrapper(field, fieldElement);
    }

    fieldTypePassword(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldElement = document.createElement("input");
        this.addAttribute(fieldElement, "id", 'form-' + this.uniqueId + '-fieldelem-' + field.id);
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttributeFromFieldSettings(fieldElement, "type", field.settings, "fieldType", "password");
        this.addAttributeFromFieldSettings(fieldElement, "maxlength", field.settings, "maximumLength", "");
        this.addAttributeFromFieldSettings(fieldElement, "placeholder", field.settings, "placeholder", "");
        this.addAttributeFromFieldSettings(fieldElement, "value", field.settings, "defaultValue", "");

        return this.addStandardFieldWrapper(field,  fieldElement);
    }

    fieldTypeMultipleChoice(field) {
        this.formDataTypes[field.alias] = this.dataType.array;

        const fieldElement = document.createElement("div");

        if(field.preValues.length > 0) {
            for(var i = 0; i < field.preValues.length; i++) {
                const caption = field.preValues[i].caption;
                const value = field.preValues[i].value;

                const row = document.createElement('div');
                const option = document.createElement('label');

                const checkbox = document.createElement('input');
                this.addAttribute(checkbox, 'name', field.alias);
                this.addAttribute(checkbox, 'type', 'checkbox');
                this.addAttribute(checkbox, 'value', value);

                const textElement = document.createElement('span');
                textElement.innerText = caption;

                option.appendChild(checkbox);
                option.appendChild(textElement);

                row.appendChild(option);
                fieldElement.appendChild(row);
            }
        }

        return this.addStandardFieldWrapper(field,  fieldElement);
    }

    fieldTypeSingleChoice(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldElement = document.createElement("div");

        if(field.preValues.length > 0) {
            for(var i = 0; i < field.preValues.length; i++) {
                const caption = field.preValues[i].caption;
                const value = field.preValues[i].value;

                const row = document.createElement('div');
                const option = document.createElement('label');

                const checkbox = document.createElement('input');
                this.addAttribute(checkbox, 'name', field.alias);
                this.addAttribute(checkbox, 'type', 'radio');
                this.addAttribute(checkbox, 'value', value);

                const textElement = document.createElement('span');
                textElement.innerText = caption;

                option.appendChild(checkbox);
                option.appendChild(textElement);

                row.appendChild(option);
                fieldElement.appendChild(row);
            }
        }
        return this.addStandardFieldWrapper(field, fieldElement);
    }

    fieldTypeTitleDescription(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldElement = document.createElement('div');
        this.addAttribute(fieldElement, 'class', 'content')

        const titleElement = document.createElement(field.settings.captionTag);
        this.addAttribute(titleElement, 'class', 'title');
        titleElement.innerHTML = field.settings.caption;

        const descriptionElement = document.createElement('div');
        this.addAttribute(descriptionElement, 'class', 'description');
        descriptionElement.innerHTML = field.settings.bodyText.replace(/[\r\n]/g, '<br>');

        fieldElement.appendChild(titleElement);
        fieldElement.appendChild(descriptionElement);

        if(field.settings.showLabel === 'True' || field.settings.showLabel === '') {
            return this.addStandardFieldWrapper(field, fieldElement);
        }
        else {
            return this.addSimpleFieldWrapper(field, fieldElement);
        }

    }

    fieldTypeDataConsent(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldLabel = document.createElement('label');

        const fieldElement = document.createElement("input");
        //this.addAttribute(fieldElement, "id", 'form-' + this.uniqueId + '-field-' + field.id);
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttribute(fieldElement, "type", "checkbox");

        const messageElement = document.createElement("span");
        messageElement.innerHTML = field.settings["acceptCopy"];

        fieldLabel.appendChild(fieldElement);
        fieldLabel.appendChild(messageElement);

        return this.addSimpleFieldWrapper(field, fieldLabel);
    }

    fieldTypeDropdown(field) {
        const fieldWrapper = document.createElement('div');
        this.addAttribute(fieldWrapper, 'class', 'wrapper');
        this.formDataTypes[field.alias] = this.dataType.string;

        const fieldElement = document.createElement('select');
        //this.addAttribute(fieldElement, "id", 'form-' + this.uniqueId + '-field-' + field.id);
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttributeFromFieldSettings(fieldElement, "placeholder", field.settings, "placeholder", "");



        if(field.settings.allowMultipleSelections === "True") {
            this.formDataTypes[field.alias] = this.dataType.array;

            this.addAttribute(fieldElement, 'multiple', 'multiple');
        }



        if(field.settings.selectPrompt !== '') {
            const option = document.createElement('option');
            this.addAttribute(option, 'value', '');
            this.addAttribute(option, 'selected', 'selected');
            option.innerText = field.settings.selectPrompt;
            fieldElement.appendChild(option);
        }

        if(field.preValues.length > 0) {
            for(var i = 0; i < field.preValues.length; i++) {
                const caption = field.preValues[i].caption;
                const value = field.preValues[i].value;

                const option = document.createElement('option');
                this.addAttribute(option, 'value', value);

                if(field.settings.defaultValue === value) {
                    this.addAttribute(option, 'selected', 'selected');
                }

                option.innerText = caption;
                fieldElement.appendChild(option);
            }
        }

        fieldWrapper.appendChild(fieldElement);
        if(field.settings.allowMultipleSelections === "False") {
            fieldWrapper.innerHTML += '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 12.01"><path d="M21.93,.61C21.77,.24,21.4,0,21,0H1C.6,0,.23,.24,.07,.61-.07,.99,0,1.42,.29,1.71L10.29,11.71c.4,.39,1.03,.39,1.43,0L21.71,1.71c.28-.3,.36-.72,.21-1.1"></path></svg>';
        }
        return this.addStandardFieldWrapper(field, fieldWrapper);
    }
    fieldTypeFileUpload(field) {
        this.formDataTypes[field.alias] = this.dataType.file;

        const fieldElement = document.createElement("input");
        //this.addAttribute(fieldElement, "id", 'form-' + this.uniqueId + '-field-' + field.id);
        this.addAttribute(fieldElement, "name", field.alias);
        this.addAttribute(fieldElement, "type", "file");
        if (field.fileUploadOptions.allowAllUploadExtensions === false) {
            var allowedUploadExtensions = field.fileUploadOptions.allowedUploadExtensions.map(function (value) {
                return "." + value;
            })
            var acceptValues = allowedUploadExtensions.join(",");
            this.addAttribute(fieldElement, "accept", acceptValues);
        }
        if (field.fileUploadOptions.allowMultipleFileUploads) {
            this.addAttribute(fieldElement, "multiple");
        }

        return this.addStandardFieldWrapper(field, fieldElement);
    }

    fieldTypeRecaptcha3(field) {
        this.formDataTypes[field.alias] = this.dataType.string;

        this.recaptcha.inForm = true;
        this.recaptcha.fieldId = field.id;
        const fieldElement = document.createElement('div');
        const scriptElement = document.createElement("script");
        this.addAttribute(scriptElement, "src", "https://www.google.com/recaptcha/api.js?render="+this.options.recaptchaSiteKey);
        this.addAttribute(scriptElement, "type", "application/javascript");
        var self = this;
        scriptElement.onload = function () {
            window.grecaptcha.ready(function () {
                self.recaptcha.ready = true;
            });
        };
        fieldElement.appendChild(scriptElement);

        const inputElement = document.createElement("input");
        this.addAttribute(inputElement, "type", "hidden");
        this.addAttribute(inputElement, "id", 'form-' + this.uniqueId + '-recaptcha-' + field.id);
        this.addAttribute(inputElement, "name", "g-recaptcha-response");
        fieldElement.appendChild(inputElement);


        return this.addSimpleFieldWrapper(field, fieldElement);
    }

    disableSubmit() {
        this.formElement.querySelector("[type=submit]").setAttribute("disabled", "disabled");
    }

    enableSubmit() {
        this.formElement.querySelector('[type=submit]').removeAttribute("disabled");
    }


    // ------------------------------------------------------------------------------------------------
    // Helper Methods
    // ------------------------------------------------------------------------------------------------

    addAttribute(element, name, value) {
        const attr = document.createAttribute(name);
        if (value) {
            attr.value = value;
        }
        element.setAttributeNode(attr);
    }
    addAttributeFromFieldSettings(fieldElement, attrName, settings, settingKey, defaultValue) {
        const attr = document.createAttribute(attrName);
        if (settings[settingKey] && settings[settingKey].length > 0) {
            attr.value = settings[settingKey];
        } else {
            attr.value = defaultValue;
        }
        if (attr.value !== "") {
            fieldElement.setAttributeNode(attr);
        }
    }

    addStandardFieldWrapper(field, slotElem) {

        const standardWrapper = document.createElement('div');

        let showLabel = true;
        if(typeof field.settings.showLabel !== 'undefined' && field.settings.showLabel == 'False') {
            showLabel = false;
        }

        if(showLabel) {
            this.addFieldLabelElement(standardWrapper, field);
        }


        const slotWrapper = document.createElement('div');
        this.addAttribute(slotWrapper, 'class', 'field');
        slotWrapper.appendChild(slotElem);
        standardWrapper.appendChild(slotWrapper);

        return this.addSimpleFieldWrapper(field, standardWrapper);
    }

    addSimpleFieldWrapper(field, slotElem) {
        //const fieldId = 'form-' + this.uniqueId + '-field-' + field.id;
        const fieldType = field.type.name.toLowerCase().replace(/[^a-z0-9-]+/g, '-');

        // Generate HTML structure
        const fieldWrapper = document.createElement('div');
        // this.addAttribute(fieldWrapper, 'id', fieldId);
        this.addAttribute(fieldWrapper, 'class', 'fieldtype fieldtype-' + fieldType);
        this.addAttribute(fieldWrapper, 'data-alias', field.alias);

        const slotError = document.createElement('div');
        this.addAttribute(slotError, 'class', 'error-message');
        slotError.innerHTML = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16,0C7.16,0,0,7.16,0,16s7.16,16,16,16,16-7.16,16-16C32,7.17,24.83,0,16,0m-.31,7.39c1.02,0,1.85,.83,1.85,1.85s-.83,1.85-1.85,1.85-1.85-.83-1.85-1.85h0c0-1.02,.83-1.84,1.85-1.85m1.54,17.23h-1.23c-.68,0-1.23-.55-1.23-1.23v-7.39c-.68,0-1.23-.55-1.23-1.23s.55-1.23,1.23-1.23h1.23c.68,0,1.23,.55,1.23,1.23v7.38c.68,0,1.23,.55,1.23,1.23s-.55,1.23-1.23,1.23" /></svg>';

        const errorMsg = document.createElement('div');
        this.addAttribute(errorMsg, 'class', 'msg');
        slotError.appendChild(errorMsg);

        fieldWrapper.appendChild(slotElem);
        fieldWrapper.appendChild(slotError);

        return fieldWrapper;
    }

    addFieldLabelElement(element, field) {
        const labelElement = document.createElement("label");
        labelElement.innerText = field.caption;
        if(field.required) {
            labelElement.innerText += ' *';
        }

        const forAttr = document.createAttribute("for");
        forAttr.value = 'form-' + this.uniqueId + '-fieldelem-' + field.id;
        labelElement.setAttributeNode(forAttr);
        element.appendChild(labelElement);

        // TODO Help Text
        // if (field.helpText && field.helpText.length > 0) {
        //     const helpTextElement = document.createElement("small");
        //     helpTextElement.innerText = field.helpText;
        //     element.appendChild(helpTextElement);
        // }
    }

    async getFileAsBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const result = reader.result;
                if (typeof result === "string") {
                    resolve("data:" + file.type + ";base64," + result.split(",")[1]);
                } else {
                    reject("Error reading file as base64.");
                }
            };
            reader.onerror = (error) => reject(error);
        });
    }
}
